export const formatTimeAgo = (date: Date) => {
  //Format the date to be X minutes ago, X hours ago, X days ago
  const dateObject = date instanceof Date ? date : new Date(date);
  const minutes = Math.floor(
    (new Date().getTime() - dateObject.getTime()) / (1000 * 60)
  );

  if (minutes < 60) {
    return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  } else if (minutes < 1440) {
    // less than 24 hours
    const hours = Math.floor(minutes / 60);
    return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  } else {
    const days = Math.floor(minutes / 1440);
    return `${days} day${days !== 1 ? "s" : ""} ago`;
  }
};

export const formatDate = (date: Date | string) => {
  //Format the date to be in the user's time zone
  const dateObj = typeof date === "string" ? new Date(date) : date;
  const timeZoneOffset = dateObj.getTimezoneOffset();
  const hours = Math.abs(Math.floor(timeZoneOffset / 60));
  const minutes = Math.abs(timeZoneOffset % 60);
  const sign = timeZoneOffset > 0 ? "-" : "+";

  return `${dateObj.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "medium",
  })} (GMT${sign}${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")})`;
};
